import {
  IonBadge,
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonIcon,
  IonNote,
  IonRouterLink,
  IonRow,
  IonText,
  useIonRouter,
} from "@ionic/react";
// import { bookmarkOutline, shareOutline } from "ionicons/icons";

import "./Post.css";
import { truncate } from "../../utils/truncate";
import SocialLinks from "../../blog/SocialLinks";
import { arrowForward } from "ionicons/icons";
const createSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-") // Replace non-alphanumeric with hyphens
    .replace(/^-+|-+$/g, ""); // Remove leading/trailing hyphens
};
export const Post = ({ post }) => {
  const CONTENT_PREVIEW_LENGTH = 190;
  const router = useIonRouter();
  if (!post.inLanding) return null;

  return (
    <IonCard
      className="shadow info-post-card landing-card"
      // routerLink={`/blog/${post.id}`}
      style={{
        display: "flex", // Enable flex for internal alignment
        flexDirection: "column", // Stack content vertically
        height: "97%", // Fill the IonCol height
        width: "97%", // Fill the IonCol width
        margin: "1.5%", // Reset margin to avoid layout shifts\
        borderRadius: "23px",
      }}
    >
      <img src={post.image} alt="main post" className="blog-image" />

      <IonCardHeader>
        <IonRow className="ion-align-items-center ion-justify-content-between">
          <IonRow
            className="ion-align-items-center ion-justify-content-between"
            style={{ padding: "10px 25px 0" }}
          >
            <h1
              className="blog-title"
              style={{
                marginTop: "0.75rem",
                color: "#000",
                // marginBottom: "0.75rem",
              }}
            >
              {post?.title}
            </h1>
          </IonRow>
        </IonRow>
      </IonCardHeader>
      <IonCardContent
        className="post-card-content"
        style={{
          marginLeft: "10px",
          paddingLeft: "15px",
          marginRight: "10px",
          paddingRight: "15px",
          flexGrow: 1, // This forces the content area to expand and push the bottom down
          minHeight: "130px",
          // paddingBottom: "10px",
          // marginBottom: "10px",
        }}
      >
        <div className="blog-content-wrapper">
          <div className="blog-content">{post?.summary}</div>
          {post.inBlog ? (
            <div
              className="read-more"
              onClick={() => router.push(`/blog/${post?.id}`)}
            >
              <div>Learn More</div>
              <IonIcon icon={arrowForward} />
            </div>
          ) : (
            <div
              className="read-more"
              onClick={() => router.push(`/${post?.id}`)}
            >
              <div>Learn More</div>
              <IonIcon icon={arrowForward} />
            </div>
          )}
        </div>
      </IonCardContent>
    </IonCard>
  );
};
